import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';
import { selectConnectUrl } from "../../Mobile/store";
import { ConvergentAccumulators } from "../ConvergentAccumulators";
import { ConvergentAddress } from "../ConvergentAddress";
import styles from "./styles.pcss";
import { selectIsConvergent } from "../../store/selectors";
var cn = classNames.bind(styles);
export var _ConvergentBlock = function _ConvergentBlock(_ref) {
  var connectionUrl = _ref.connectionUrl;
  return /*#__PURE__*/React.createElement("a", {
    "aria-label": "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0434\u0435\u0442\u0430\u043B\u0438 \u0442\u0430\u0440\u0438\u0444\u0430",
    className: cn('block-link'),
    href: connectionUrl,
    "data-t-id": "components-ConvergentBlock"
  }, /*#__PURE__*/React.createElement(ConvergentAddress, null), /*#__PURE__*/React.createElement(ConvergentAccumulators, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    connectionUrl: selectConnectUrl(state),
    shouldRender: selectIsConvergent(state)
  };
};
var connector = connect(mapStateToProps);
export var ConvergentBlock = compose(connector, withRenderFlag)(_ConvergentBlock);